var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgF1BookVisit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69 63.58V70H45v-6.42A4.53 4.53 0 0149.44 59h15.09A4.53 4.53 0 0169 63.58zM64 17h-5v-5h-3v8h8v-3zM53.88 48.11a5 5 0 106.204 7.843 5 5 0 00-6.204-7.843zm-6.71-30.69a11.41 11.41 0 1111.41 11.41 11.43 11.43 0 01-11.41-11.41zm3 0A8.41 8.41 0 1058.58 9a8.42 8.42 0 00-8.41 8.42zm-21.69 9.51A13.22 13.22 0 0017.85 22H7v21h16V28.86L37 44.6a2.65 2.65 0 003.73.23 3 3 0 00.64-.82 2.73 2.73 0 00-.45-3.08l-12.44-14zm7 32.07H20.44A4.53 4.53 0 0016 63.58V70h24v-6.42A4.53 4.53 0 0035.53 59h-.05zm-4.41-3.07a5 5 0 10-7-.79 4.999 4.999 0 007.05.79h-.05zM18 18.19a6 6 0 10-7.442-9.411A6 6 0 0018 18.19z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/F1_Book_visit.71a1d346.svg";
export { SvgF1BookVisit as ReactComponent };